import React, { Component, RefObject } from "react";
import obypay_logo from '../../assets/images/logo-obypay.png';
import obyPayActionCreator from "../../controller/action/ObyPayActionCreator";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import Service from "../../controller/model/service/Service";
import AppStore from "../../controller/store/AppStore";
import ObyPayStore from "../../controller/store/ObyPayStore";
import WithStyles from "../utils/WithStyles";
import ObypayConnected from "./ObypayConnected";
import ObypayLogin from "./ObypayLogin";
import { AlertSeverity } from "./_interfaces/obypay";
import { SelectChangeEvent } from "@mui/material";

interface ObyPayState {
    service: Service
    showError: boolean
    message: string | undefined
    alertSeverity: AlertSeverity
    isLoading: boolean
    showAlert: boolean
    tokenRef: RefObject<HTMLInputElement>
    signatureKeyRef: RefObject<HTMLInputElement>,
    popinaRestaurant: PopinaRestaurant
    showPaymentMappingDialog: boolean
    paymentMapping: {
        pos_card: string
        pos_lunchvoucher: string
        online_card: string
        online_wallet: string
        online_bancontact: string
        online_lunchvoucher: string
        online_intercard: string
        online_bankroll: string
        online_epro: string
    }
}

class ObypayContainer extends Component {
    public state: ObyPayState;

    constructor(props: ObyPayState) {
        super(props);
        this.state = {
            service: ObyPayStore.service,
            showError: false,
            message: "",
            isLoading: false,
            showAlert: false,
            showPaymentMappingDialog: false,
            alertSeverity: AlertSeverity.INFO,
            tokenRef: React.createRef<HTMLInputElement>(),
            signatureKeyRef: React.createRef<HTMLInputElement>(),
            popinaRestaurant: AppStore.restaurant,
            paymentMapping: {
                pos_card: '',
                pos_lunchvoucher: '',
                online_card: '',
                online_wallet: '',
                online_bancontact: '',
                online_lunchvoucher: '',
                online_intercard: '',
                online_bankroll: '',
                online_epro: ''
            }
        };
        this._logout = this._logout.bind(this)
        this._closeSnackBar = this._closeSnackBar.bind(this)
        this._closePaymentDialog = this._closePaymentDialog.bind(this)
        this._connectService = this._connectService.bind(this)
        this._openPaymentMappingDialog = this._openPaymentMappingDialog.bind(this)
    }

    componentDidMount(): void {
        obyPayActionCreator.loadService().catch((err) => { console.error(err) })
        ObyPayStore.addChangeListener(this._onServiceChange.bind(this));
        AppStore.addChangeListener(this._onPopinaRestaurantChange.bind(this));
    }

    _onServiceChange(): void {
        this.setState({ service: ObyPayStore.service });
    }

    _onPopinaRestaurantChange(): void {
        this.setState({ popinaRestaurant: AppStore.restaurant });
    }

    _validateRequiredInput(inputRef: RefObject<HTMLInputElement>, errorMessage: string): string | null {
        const inputValue = inputRef.current?.value

        if (!inputValue) {
            this.setState({ showError: true, showAlert: true, message: errorMessage, alertSeverity: AlertSeverity.ERROR})
            this.setState({ isLoading: false })
            return null
        }
        return inputValue
    }

    _connectService() {
        const { tokenRef, signatureKeyRef } = this.state

        const token = this._validateRequiredInput(tokenRef, "Veuillez saisir votre token")
        const key = this._validateRequiredInput(signatureKeyRef, "Veuillez saisir votre clé")

        if (token && key) {
            this.setState({ isLoading: true })
            obyPayActionCreator.validateObyPayUser(token, key).then(() => {
                this.setState({ isLoading: false })
                this.setState({ showAlert: true, message: "Connexion réussie", alertSeverity: AlertSeverity.SUCCESS })
            }).catch((error) => {
                this.setState({ isLoading: false })
                this.setState({ showAlert: true, message: `${error}`, alertSeverity: AlertSeverity.ERROR, showError: true })
            })
        }
    }

    _handleSelectValueChange = (selectedValue: SelectChangeEvent<string>, obypayPaymentValue: string) => {
        this.setState((prevState: ObyPayState) => ({
            paymentMapping: {
              ...prevState.paymentMapping,
              [obypayPaymentValue]: selectedValue.target.value
            }
        }));
    }

    _setPaymentMapping = () => {
        const paymentMapping = obyPayActionCreator.formatPaymentMappingForRequest(this.state.paymentMapping)
        obyPayActionCreator.setPaymentMapping(this.state.service.accessToken ?? "", paymentMapping).then(() => {
            this.setState({ showPaymentMappingDialog: false })
            this.setState({ showAlert: true, message: "Mapping effectué", alertSeverity: AlertSeverity.SUCCESS })
        }).catch((error) => {
            if (error instanceof Error) {
                this.setState({ showAlert: true, showError: true, message: error.message, alertSeverity: AlertSeverity.ERROR })
            }
        })
    }

    _logout() {
        this.setState({ isLoading: true })
        obyPayActionCreator.disconnectService(this.state.service.accessToken?? "").then(() => {
            this.setState({ showPaymentMappingDialog: false })
            this.setState({ isLoading: false })
            this.setState({ showAlert: true, message: "Déconnexion réussie", alertSeverity: AlertSeverity.SUCCESS })
        }).catch((error) => {
            this.setState({ isLoading: false })
            if (error instanceof Error) {
                this.setState({ showAlert: true, showError: true, message: error.message, alertSeverity: AlertSeverity.ERROR})
            }
        })
    }

    _closeSnackBar() {
        this.setState({ showError: false, message: "", showAlert: false });
    }

    _closePaymentDialog() {
        this.setState({ showPaymentMappingDialog: false })
    }

    _openPaymentMappingDialog() {
        this.setState({ showPaymentMappingDialog: true })
    }

    render() {
        return (
            <div>
                <img src={obypay_logo} alt='Obypay logo' />
                {
                    this.state.service.isActive ? 
                        <StyledObyPayConnected 
                            _logout={this._logout} 
                            service={this.state.service}
                            _closeSnackBar={this._closeSnackBar}
                            alertSeverity={this.state.alertSeverity}
                            message={this.state.message}
                            showAlert={this.state.showAlert}
                            showPaymentMappingDialog={this.state.showPaymentMappingDialog}
                            _setPaymentMapping={this._setPaymentMapping}
                            restaurant={this.state.popinaRestaurant}
                            _handleSelectValueChange={this._handleSelectValueChange}
                            paymentMapping={this.state.paymentMapping}
                            _closePaymentMappingDialog={this._closePaymentDialog}
                            _openPaymentMappingDialog={this._openPaymentMappingDialog}
                        /> 
                        : 
                        <StyledObyPayLogin 
                            tokenRef={this.state.tokenRef} 
                            keyRef={this.state.signatureKeyRef} 
                            isLoading={this.state.isLoading}
                            showAlert={this.state.showAlert}
                            alertSeverity={this.state.alertSeverity}
                            message={this.state.message}
                            _closeSnackBar={this._closeSnackBar}
                           _connectService={this._connectService}
                        />
                }
            </div>
        )
    }
}

export default ObypayContainer;
const StyledObyPayLogin = WithStyles(ObypayLogin)
const StyledObyPayConnected = WithStyles(ObypayConnected)